const GTM_MAP = {
  us: 'GTM-T56B7NR',
  sg: 'GTM-MMQQF2D',
  hk: 'GTM-TQ5842K8',
  tm: 'GTM-NCVVKMC',
  cn: 'GTM-54KZR44N',
  uk: 'GTM-WPN7K65G',
  fr: 'GTM-M3J9VLXM',
  ca: 'GTM-W7R4PTP9',
  jp: 'GTM-W2KD6K5F',
  kr: 'GTM-PH8GZQVD',
  au: 'GTM-MVBHLRRN',
  my: 'GTM-P4FVN5LD',
  bmus: 'GTM-MSKZJRWP',
  bmsg: 'GTM-PJSFXBX2',
};

// 通用注入
function injectScript({
  id, src, innerHTML, async = false, defer = true, type = 'text/javascript', place = 'head',
  fetchPriority,
}) {
  if (id && document.getElementById(id)) return;

  const script = document.createElement('script');
  script.type = type;
  script.async = async;
  script.defer = defer;
  if (fetchPriority) {
    try { script.fetchPriority = fetchPriority; } catch (e) { /* no-op */ }
  }
  if (id) script.id = id;
  if (src) script.src = src;
  if (innerHTML) script.textContent = innerHTML;

  (place === 'body' ? document.body : document.head).appendChild(script);
}

function injectMeta(name, content) {
  const meta = document.createElement('meta');
  meta.name = name;
  meta.content = content;
  document.head.appendChild(meta);
}

function injectJsonLd(json) {
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(json);
  document.head.appendChild(script);
}

function pushPageView(to) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview',
    page: {
      path: to.fullPath,
      title: document.title,
    },
  });
}

// 用于推迟加载非关键脚本
function idleOrLoad(callback) {
  const run = () => {
    if ('requestIdleCallback' in window) {
      try { requestIdleCallback(callback, { timeout: 3000 }); return; } catch (e) { /* fallthrough */ }
    }
    setTimeout(callback, 0);
  };
  if (document.readyState === 'complete') {
    run();
  } else {
    window.addEventListener('load', run, { once: true });
  }
}

function injectLinkRel(rel, href, crossOrigin) {
  if (!href) return;
  try {
    const id = `link-${rel}-${href}`.replace(/[^a-z0-9_-]/gi, '');
    if (document.getElementById(id)) return;
    const link = document.createElement('link');
    link.id = id;
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = crossOrigin;
    document.head.appendChild(link);
  } catch (e) { /* no-op */ }
}

export default ({ app, store }) => {
  if (process.server) return;
  app.router.afterEach((to) => {
    pushPageView(to);
  });
  if (process.env.runtime !== 'prod' && process.env.runtime !== 'preprod') {
    console.info('[GTM] Skipped because runtime != prod/preprod');
    return;
  }

  const { locale } = store.state;
  const gtmId = GTM_MAP[locale];

  if (!gtmId) {
    console.warn('[GTM] No GTM ID configured for locale:', locale);
    return;
  }

  // Resource hints to reduce connection overhead without changing script timing
  injectLinkRel('preconnect', 'https://www.googletagmanager.com', 'anonymous');
  injectLinkRel('dns-prefetch', 'https://www.googletagmanager.com');
  if (locale === 'us' || locale === 'tm') {
    injectLinkRel('preconnect', 'https://www.google-analytics.com', 'anonymous');
    injectLinkRel('dns-prefetch', 'https://www.google-analytics.com');
  }
  if (locale === 'tm') {
    injectLinkRel('preconnect', 'https://cdn.mediago.io', 'anonymous');
    injectLinkRel('dns-prefetch', 'https://cdn.mediago.io');
  }

  // 初始化 dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  // 为 GTM 设置默认拒绝的同意状态，避免在关键渲染阶段触发第三方标签，降低阻塞时间
  window.dataLayer.push({
    event: 'default_consent',
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  });

  // 核心脚本延后执行以降低总阻塞时间
  // 将 GTM 主脚本的加载推迟到 load/idle 之后，显著减少首屏阶段的主线程占用
  // 同时保留前置的 dataLayer 与默认同意设置，确保标签配置的正确性
  idleOrLoad(() => {
    injectScript({
      id: 'gtm-script',
      src: `https://www.googletagmanager.com/gtm.js?id=${gtmId}`,
      defer: true,
    });
    // 次要脚本延后执行
    if (locale === 'us') {
      injectScript({
        src: 'https://www.googletagmanager.com/gtag/js?id=G-TVWXFPZ427',
        defer: true,
        fetchPriority: 'low',
      });
      injectScript({
        innerHTML: `
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-TVWXFPZ427');
        `,
      });
    }

    if (locale === 'sg') {
      injectJsonLd({
        '@context': 'https://schema.org',
        '@type': 'Product',
        name: 'Primary School Math Olympiad Training (Novena)',
        description: 'Primary School Math Olympiad Training (Novena)',
        url: 'https://www.thinkacademy.sg/courses/list',
        brand: {
          '@type': 'Brand',
          logo: 'https://download-pa-s3.thethinkacademy.com/static-pa/project/thinkacademy-website-web/prod/images/2cea6ff.png',
        },
        offers: {
          '@type': 'Offer',
          price: 'S$70 /lesson',
        },
      });

      injectJsonLd({
        '@context': 'https://schema.org',
        '@type': 'LocalBusiness',
        name: 'Think Academy Singapore',
        image: 'https://download-pa-s3.thethinkacademy.com/static-pa/project/thinkacademy-website-web/prod/images/2cea6ff.png',
        telephone: '+65 8285 3984',
        address: {
          '@type': 'PostalAddress',
          streetAddress: '10 Sinaran Dr, #03-26 29 Square 2, Singapore 307506',
          addressCountry: 'Singapore',
          postalCode: '307506',
        },
        openingHoursSpecification: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: {
            '@type': 'DayOfWeek',
            name: 'Tuesday-Sunday',
          },
          opens: 'Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30',
          closes: 'Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30',
        },
        url: 'https://www.thinkacademy.sg/',
      });
    }

    if (locale === 'tm') {
      injectMeta('google-site-verification', 'No76MogO-xIQWedlvvMnVLKHl2LIlGfjK1eHQXwmIP8');
      injectMeta('ahrefs-site-verification', 'd4ac6f00f5bbd6bf9271a100c1a0903fa7683b1a7fdf5e8a59dc5a52c51ef95f');

      injectScript({
        innerHTML: `
          window._megoaa = window._megoaa || [];
          window._megoaa.push({ type: 'event', name: 'pageview' });
          window._megoaa.push({ type: 'nextjump', link: ["think-matrix.com"] });
          !function(t,f,a,x){
            if(!document.getElementById(x)){
              t.async=1;t.src=a;t.id=x;f.parentNode.insertBefore(t,f);
            }
          }(document.createElement('script'), document.getElementsByTagName('script')[0], '//cdn.mediago.io/js/pixel.js', 'pixel_megoaa_script');
        `,
      });

      injectScript({
        src: 'https://www.googletagmanager.com/gtag/js?id=AW-11168801903',
        async: false,
        fetchPriority: 'low',
      });
      injectScript({
        innerHTML: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-11168801903', { 'allow_enhanced_conversions': true });
        `,
      });
      injectScript({
        innerHTML: `
          window.addEventListener('load', function () {
            document.querySelectorAll('[class="not-logged-in"]').forEach(function (e) {
              e.addEventListener('click', function () {
                document.querySelectorAll("button.el-button.button.login-button.new-login-font.el-button--primary").forEach(function(btn) {
                  btn.addEventListener('click', function () {
                    var email = document.querySelector('[placeholder="Email Address"]').value;
                    if (email && email.includes("@")) {
                      gtag("set", "user_data", { email: email });
                      gtag("event", "conversion", { send_to: "AW-11168801903/D1EGCIa97-MYEO_I2c0p" });
                    }
                  });
                });
              });
            });
          });
        `,
        defer: true,
      });

      injectScript({
        innerHTML: `
          window.addEventListener('load', function () {
            document.querySelectorAll('[class="info-text"]').forEach(function (e) {
              e.addEventListener('click', function () {
                setTimeout(function () {
                  document.querySelectorAll('[class="normal"]').forEach(function(btn) {
                    btn.addEventListener('click', function () {
                      var area = document.querySelector("li.el-select-dropdown__item.phone-area-code-option.selected > div > div.area-code").innerText.split(" ")[1].split("\\n")[0];
                      var phone = document.querySelector('[placeholder="Mobile Phone"]').value;
                      var full = area + phone;
    
                      if (phone && area) {
                        gtag("set", "user_data", { phone_number: full });
                        gtag("event", "conversion", { send_to: "AW-11168801903/D1EGCIa97-MYEO_I2c0p" });
                      }
                    });
                  });
                }, 1500);
              });
            });
          });
        `,
        defer: true,
      });

      injectScript({
        innerHTML: `
          window.addEventListener('load', function () {
            if (window.location.href.includes("/order/result/")) {
              var transaction_id = Date.now();
              var currency = "USD";
              var price = localStorage.getItem("price");
              gtag("event", "conversion", {
                send_to: "AW-11168801903/tUaoCKyp6eMYEO_I2c0p",
                transaction_id: transaction_id,
                value: price,
                currency: currency
              });
            }
          });
        `,
        defer: true,
      });
    }
  });
};
